require('../clipFilterService');
require('../clipSearchService');

angular.module('app.shared.clipSearch.filterDirective.filterController', [
  'app.shared.clipSearch.clipFilterService',
  'app.shared.clipSearchService',
])
  .controller('app.shared.clipSearch.filterDirective.filterController', [
    '$scope',
    'app.shared.clipSearch.clipFilterService',
    '$rootScope',
    'app.shared.clipSearchService',
    function ($scope, clipFilterService, $rootScope, clipSearchService) {
      "use strict";

      if (!$scope.filterData) {
        $scope.filterData = {
          filters: {},
          labels: {},
          preset: null
        };
      }

      $scope.cachedFilterData = $scope.cachedFilterData || null;

      $scope.filterCount = 0;

      $scope.hideFilterActions = $scope.hideFilterActions || null;

      $scope.canUpdatePresets = $scope.canUpdatePresets || false;

      $scope.hideClipCount = $scope.hideClipCount || false;

      $scope.defaultValue = $scope.defaultValue || false;

      $scope.clipCount = null;

      if (!$scope.button) {
        $scope.button = {
          class: 'btn-light',
          text: 'Clear Filter',
          click: () => {
            if (angular.isObject($scope.filterData.filters)) {
              for (let i in $scope.filterData.filters) {
                if ($scope.filterData.filters.hasOwnProperty(i)) {
                  delete $scope.filterData.filters[i];
                }
              }
            }
          }
        };
      }

      let init = () => {
        countLabels();

        if (!$scope.filterCount || !$scope.defaultValue) {
          clipFilterService.getFilterLabels($scope.filterData.filters)
            .then(
              response => {
                let data = response.data;

                if (data.error) {
                  alert(data.error);
                } else {
                  if (angular.isObject(data) && !Array.isArray(data)) {
                    $scope.filterData.labels = data;
                  } else {
                    $scope.filterData.labels = {};
                  }
                }
              }
            );
        }
      };

      let countLabels = () => {
        let count = 0;
        for (let i in $scope.filterData.labels) {
          if ($scope.filterData.labels.hasOwnProperty(i)) {
            if ($scope.filterData.labels[i]) {
              count += 1;
            }
          }
        }

        $scope.filterCount = count;
        $rootScope.$broadcast('forward_filter_count', {filterCount: $scope.filterCount});
      };

      let getClipCount = () => {
        let filters = angular.copy($scope.filterData.filters);

        clipSearchService.retrieve(filters)
          .then(
            response => {
              let data = response.data;

              if (data.error) {
                alert(data.error);
              } else {
                $scope.clipCount = parseInt(data.count);
                $rootScope.$broadcast('forward_clip_count', {clipCount: $scope.clipCount, filterCount: $scope.filterCount});
              }
            }
          );
      };

      $scope.removeFilter = label_id => {
        let parts = label_id.split('-');

        if (angular.isObject($scope.filterData.filters) && (typeof $scope.filterData.filters[parts[0]] !== 'undefined' || $scope.filterData.preset)) {
          switch (parts[0]) {
            case 'starred':
              $scope.filterData.filters[parts[0]] = null;
              break;
            case 'opponent_league':
              delete $scope.filterData.filters[parts[0]];

              if(angular.isDefined($scope.filterData.filters['opponent_team'])) {
                delete $scope.filterData.filters['opponent_team'];
              }

              if(angular.isDefined($scope.filterData.filters['opponents'])) {
                delete $scope.filterData.filters['opponents'];
              }

              for (let i in $scope.filterData.labels) {
                if ($scope.filterData.labels.hasOwnProperty(i)) {
                  if (i.match(/^opponent_team/)) {
                    delete $scope.filterData.labels[i];
                  }

                  if (i.match(/^opponents/)) {
                    delete $scope.filterData.labels[i];
                  }
                }
              }
            break;
            case 'opponent_team':
              delete $scope.filterData.filters[parts[0]];

              if(angular.isDefined($scope.filterData.filters['opponents'])) {
                delete $scope.filterData.filters['opponents'];
              }

              for (let i in $scope.filterData.labels) {
                if ($scope.filterData.labels.hasOwnProperty(i)) {
                  if (i.match(/^opponents/)) {
                    delete $scope.filterData.labels[i];
                  }
                }
              }
              break;
            case 'preset':
              delete $scope.filterData.filters[parts[0]];
              delete $scope.filterData.labels[parts[0]];
              $rootScope.$broadcast('clear_selected_preset');
              break;
            case 'my_teams':
            case 'categories':
            case 'subcategories':
            case 'strengths':
            case 'opponents':
            case 'opponent_players':
            case 'players':
            case 'seasons':
              let list = null;
              if (Array.isArray($scope.filterData.filters[parts[0]])) {
                list = $scope.filterData.filters[parts[0]];
              } else {
                list = $scope.filterData.filters[parts[0]].split(',');
              }

              let index = list.indexOf(parseInt(parts[1]));
              if (index > -1) {
                if(parts[0] === 'opponent_players') {
                  $rootScope.$broadcast('remove_player_opp_team', {player_id: parseInt(parts[1])})
                }

                list.splice(index, 1);
              }

              if($scope.filterData.filters[parts[0]].length === 0) {
                delete $scope.filterData.filters[parts[0]];

                if(parts[0] === 'opponent_players') {
                  delete $scope.filterData.filters['opponent_player_teams'];
                }
              }

              break;
          }
        } else if (parts[0] === 'date') {
          $scope.filterData.filters.start_date = null;
          $scope.filterData.filters.end_date = null;
        }

        delete $scope.filterData.labels[label_id];

        if($scope.cachedFilterData && $scope.cachedFilterData.hasOwnProperty('filters')) {
          $scope.cachedFilterData.filters = JSON.stringify($scope.filterData.filters);
        }
      };

      $scope.buttonsClass = () => {
        let ngClass = {};

        if ($scope.emptyFilterTemplate && $scope.emptyFilterTemplate.buttonClass) {
          ngClass[$scope.emptyFilterTemplate.buttonClass] = !$scope.filterCount;
        }

        if ($scope.filterTemplate && $scope.filterTemplate.buttonClass) {
          ngClass[$scope.filterTemplate.buttonClass] = $scope.filterCount;
        }


        return ngClass;
      };

      $scope.getLabelType = (label_id) => {
        switch (label_id) {
          case 'preset':
          case 'preset-1':
            return label_id;
        }
        return null;
      };

      $scope.$on('update_preset_success', (event, data)=> {
          $scope.canUpdatePresets = data.canUpdatePresets;
      });

      $scope.$watch(
        () => {
          return $scope.filterData.labels;
        },
        (newValue, oldValue) => {
          countLabels();
          getClipCount();

          if($scope.filterData.labels.hasOwnProperty('preset')) {
            $scope.canUpdatePresets = (oldValue.preset === newValue.preset && !angular.equals(oldValue, newValue));
          }
        },
        true
      );

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/clipSearch/filterDirective/filterController.js